// CongratsModal.tsx (inline in same file or extract later)
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { PartyPopper } from "lucide-react";

function formatInt(n) {
  return Number(n ?? 0).toLocaleString('en-US');
}

export function CongratsModal({
  isOpen,
  onClose,
  tokens,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      className="bg-slate-900 text-white"
      placement="center"
      size="md"
      backdrop="blur"
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-2 text-indigo-300">
          <PartyPopper className="w-5 h-5" />
          Purchase Successful
        </ModalHeader>
        <ModalBody className="flex flex-col items-center justify-center gap-3 py-6">
          <div className="text-3xl font-extrabold tracking-tight">
            🎉 Congrats!
          </div>
          <div className="text-sm text-gray-300">You’ve received</div>
          <div className="flex items-center gap-3">
            <svg className="w-7 h-7 text-indigo-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L2 12l10 10 10-10L12 2z" />
            </svg>
            <div className="text-4xl font-black">{formatInt(tokens)}</div>
            <div className="text-xl">Pixel Drops</div>
          </div>

          <div className="text-xs text-gray-400 mt-2 text-center">
            Your balance will reflect this shortly.
          </div>
        </ModalBody>
        <ModalFooter className="justify-center">
          <Button
            onPress={onClose}
            className="bg-indigo-600 border-2 border-indigo-800 rounded-full px-6"
          >
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
